import flow from 'lodash/fp/flow';
import filter from 'lodash/fp/filter';
import isEmpty from 'lodash/fp/isEmpty';
import { notEmpty } from 'util/notEmpty';

type Option<T> = T & {
  checked?: boolean;
  indeterminate?: boolean;
  children?: Option<T>[];
};

export function cascadeCheck<T>(options?: Option<T>[]): Option<T>[] {
  return (options || []).map((option: Option<T>) => {
    const children = cascadeCheck(option.children);
    const checked =
      (isEmpty(children) && option.checked) || hasChecked(children);
    const indeterminate = checked && hasUnchecked(children);
    return { ...option, checked, indeterminate, children };
  });
}

export const hasUnchecked = flow(
  filter((option: Option<any>) =>
    Boolean(!option.checked || option.indeterminate),
  ),
  notEmpty,
);

export const hasChecked = flow(
  filter((option: Option<any>) => Boolean(option.checked)),
  notEmpty,
);
